import React, { useState, useEffect } from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import policyTextEn from './policy_en.js';
import policyTextRu from './policy_ru.js';

function App() {
  const [language, setLanguage] = useState('en'); // 'en' or 'ru'
  const [contentVisible, setContentVisible] = useState(true);

  const policies = {
    en: {
      title: 'Privacy Policy (English)',
      text: policyTextEn,
    },
    ru: {
      title: 'Политика Конфиденциальности (Русский)',
      text: policyTextRu,
    },
  };

  const changeLanguage = (lang) => {
    if (lang !== language) {
      setContentVisible(false); // Start fade-out
      // Delay language change and fade-in to allow fade-out animation to complete
      setTimeout(() => {
        setLanguage(lang);
        setContentVisible(true); // Start fade-in
      }, 400); // Should match the CSS transition duration for opacity/transform
    }
  };

  const currentPolicy = policies[language];

  return (
    <>
      <div className="app-title">Gen Waifu - Privacy Information</div>
      <div className="container">
        <div className="lang-switcher">
          <button 
            onClick={() => changeLanguage('en')} 
            className={language === 'en' ? 'active' : ''}
          >
            English
          </button>
          <button 
            onClick={() => changeLanguage('ru')} 
            className={language === 'ru' ? 'active' : ''}
          >
            Русский
          </button>
        </div>
        <div className="policy-display-area">
          <PrivacyPolicy 
            title={currentPolicy.title} 
            policyText={currentPolicy.text} 
            isVisible={contentVisible} 
          />
        </div>
      </div>
    </>
  );
}

export default App; 